import React from 'react';
import { BringzzText, BringzzIcon, BringzzAccordion } from "@bringzz/components";
import { getProductGroups } from './constants';
import classNames from 'classnames';
import { useNavigation } from 'context/NavigationContext';
import { useTranslation } from 'react-i18next';
import RxIcon from 'assets/images/28px_bold.svg';

const ProductGroups = () => {
    const { t } = useTranslation();
    const { navigate } = useNavigation();
    const productGroups = getProductGroups(t);

    const handleProductGroupClick = (group) => {
        if (group.isRxProducts) {
            navigate('/search/prescription-medicine');
        }
    };

    return (
        <div className='mt-2 mx-2 space-y-2'>
            <BringzzAccordion 
                className='px-6 bg-white rounded-xl' 
                title={<BringzzText tag='h4'>{t('component.search.product_groups.title') || 'Product Groups'}</BringzzText>}
                icon={{
                    expanded: <BringzzIcon icon="IconMinu" folder="LineIcons" size="16" />, 
                    closed: <BringzzIcon icon="IconPlus" folder="LineIcons" size="16" />
                }}
            >
                {productGroups.map((group, idx) => (
                    <div
                        key={idx}
                        className={classNames(
                            'flex items-center h-12 justify-between cursor-pointer',
                            idx !== productGroups.length - 1 && 'border-b'
                        )}
                        onClick={() => handleProductGroupClick(group)}
                    >
                        <div className='flex space-x-3 items-center'>
                            <img 
                                src={RxIcon} 
                                alt="Prescription"
                                className="w-9 h-9"
                            />
                            <BringzzText tag='h3' className='font-normal'>{group.shortName}</BringzzText>
                        </div>
                        <BringzzIcon size="16" icon="IconChevronRight" folder="LineIcons" />
                    </div>
                ))}
            </BringzzAccordion>
        </div>
    );
};

export default ProductGroups;
